import { Injectable } from '@angular/core';

@Injectable()
export class HttpUtilsService {
    public buildQuery(params) {
        const filterArray = params ? Object.keys(params)
            .filter(paramKey => `${params[paramKey]}`)
            .map(paramKey => `${paramKey}=${params[paramKey]}`) : [];
        return filterArray.length > 0 ? `${filterArray.join('&')}` : '';
    };
}